



























import { SearchBuilder } from "@/builder";
import { debounceProcess } from "@/helpers/debounce";
import { useProduct } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ProductResponseDto } from "@/models/interface/master-product";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * @description select component product by po product type
 */
@Component
export default class SelectProductByType extends Vue {
  @Prop({ required: true, type: String, default: "" })
  value!: string;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ required: false, type: String, default: "code" })
  optionLabel!: "code" | "name";

  @Prop({ required: false, type: String, default: "" })
  productType!: string;

  options: Option<ProductResponseDto>[] = [];
  loading = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);
  }

  @Watch("productType", { immediate: true })
  onChangeProductType(): void {
    const params = new RequestQueryParams(this.buildQuery());
    this.fetchOptions(params);
  }

  fetchOptions(params: RequestQueryParams): void {
    const { findAll } = useProduct();

    this.loading = true;
    findAll(params)
      .then(({ data }) => {
        this.options = data.map(item => ({
          label: item[this.optionLabel],
          value: item.id,
          key: item.id,
          meta: item,
        }));
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { searchBy } = useProduct();
    const builder = new SearchBuilder();
    const params = new RequestQueryParams();
    const defaultQuery: string[] = [];
    const searchByType: string = this.buildQuery();
    const filtered: string = searchBy({ [this.optionLabel]: val });

    if (searchByType) {
      defaultQuery.push(searchByType);
    }

    if (filtered) {
      defaultQuery.push(filtered);
    }

    params.search = defaultQuery.join(builder.AND);

    this.fetchOptions(params);
  }

  findOption(value: string): Option<ProductResponseDto> | undefined {
    return this.options.find(e => value === e.value);
  }

  /**
   * build default query
   */
  buildQuery(): string {
    const builder = new SearchBuilder();
    if (this.productType) {
      return builder.push(["type", this.productType]).build();
    }

    return "";
  }
}
